/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import IconCheckedSuccess from "../../components/atoms/IconCheckedSuccess"
import Footer from "../../components/main/Footer"
import { Topbar } from "../../components/organisms/Topbar"
import { TENANTS } from "../../constants"
import { initPdiComponent } from "../../core/service/BusinessLogicService"
import { isPdiRetailTenant, loc } from "../../core/utils"
import PdiRetailAcceptanceContent from "./components/PdiRetailAcceptanceContent"
import ShopRedirectCountdown from "./components/ShopRedirectCountdown"
import { hasSamsungShopRedirectCountdown } from "./utils/samsungShopRedirectTenants"
import React, { Component } from "react"
import { Button, Col, Container, Row } from "react-bootstrap"

class FinalPage extends Component {
  componentDidMount() {
    initPdiComponent("FinalPage")
  }

  render() {
    const { tunnelData } = this.props
    const { tenant, data } = tunnelData
    const commandAcceptedShopUrl = tunnelData?.commandAcceptedShopUrl?.replace("OPL", tunnelData.opl)
    const products = data?.order?.products[0] || {}
    const showShopRedirectCountdown = hasSamsungShopRedirectCountdown(tenant)

    const Body = () => (
      <Col sm={12}>
        {/* CONTENT */}
        <Container>
          <Row className="justify-content-center">
            {isPdiRetailTenant(tenant) ? (
              <PdiRetailAcceptanceContent tunnelData={tunnelData} />
            ) : (
              <Col xs={11} sm={10} md={10} lg={6} className="hard-shadow-white-block text-center misc-mono-block">
                <IconCheckedSuccess />
                {tenant === TENANTS.BPLS ? <h1>{loc`bplsScoreOkTitle`}</h1> : <h1>{loc`Request sent`}</h1>}
                {tenant === TENANTS.BPLS ? (
                  <div>
                    <p>{loc`BPLS confirmation text`}</p>
                  </div>
                ) : null}
                {(tenant === TENANTS.SAMSUNG_ES || tenant === TENANTS.SAMSUNG_ES_APZ) && (
                  <div>
                    <ul>
                      {loc`Congratulations`} {tunnelData?.data?.order?.customer?.firstName}{" "}
                      {tunnelData?.data?.order?.customer?.name}
                    </ul>
                    <ul>
                      {loc`Product`}: {products?.designation}{" "}
                    </ul>
                    <ul>
                      {loc`№ contrato de renting`}: {tunnelData.opl}
                    </ul>
                    <ul>
                      {loc`Montly amount to be paid`}: {tunnelData?.data?.order?.rent?.monthlyTotal}
                    </ul>
                    <ul>
                      {loc`Duration`}: {tunnelData?.data?.order?.rent?.duration}
                    </ul>
                  </div>
                )}
                {tenant !== TENANTS.SAMSUNG_ES && tenant !== TENANTS.SAMSUNG_ES_APZ && tenant !== TENANTS.BPLS && (
                  <p>
                    {loc`Your file number is`} {tunnelData.opl}.
                  </p>
                )}
                {tenant === TENANTS.BPLS && (
                  <>
                    <p>
                      <b>Le(s) signataire(s) identifié(s) : </b>{" "}
                    </p>
                    {data?.customer?.signatories?.map((s) => {
                      return (
                        <p key={s.email}>
                          - {s.firstName} {s.name}, <br></br>
                          <b>e-mail :</b> {s.email}
                        </p>
                      )
                    })}
                  </>
                )}

                {tenant !== TENANTS.BPLS && (
                  <div>
                    {tenant === TENANTS.SAMSUNG_ES_APZ ? (
                      loc("Samsung APZ final page message")
                        .split(/\n\n/)
                        .map((paragraph, i) => (paragraph ? <p key={i}>{paragraph}</p> : null))
                    ) : (
                      <>
                        <p>{loc`Now, we need to review it and determine if you are eligible for our offer. A response will be provided to you within 48 hours.`}</p>
                        {tenant === TENANTS.SAMSUNG_ES && (
                          <p>{loc`We will contact you as soon as your file is treated`}</p>
                        )}
                        <p>{loc`Thank you for your trust and see you soon !`}</p>
                      </>
                    )}
                    {showShopRedirectCountdown && commandAcceptedShopUrl && (
                      <ShopRedirectCountdown shopUrl={commandAcceptedShopUrl} brandColor={tunnelData?.brandColor} />
                    )}
                    <Button href={commandAcceptedShopUrl} variant="primary" className="ico-back-small-before">
                      {loc`Back to shop`}
                    </Button>{" "}
                  </div>
                )}

                <div className="order-info-content">{tenant === TENANTS.BPLS && <p>{loc`spamWarningBpls`}</p>}</div>
              </Col>
            )}
          </Row>
        </Container>
        {/* END CONTENT */}
      </Col>
    )

    return tunnelData.nativeNetheos ? (
      <Body />
    ) : (
      <Container fluid>
        <Row noGutters>
          {/* ——————————————————————————————————————————————— */}
          {/* ———————————————————— MAIN ————————————————————— */}
          {/* ——————————————————————————————————————————————— */}
          <Col className="misc-block">
            <Row>
              <Topbar tunnelData={this.props?.tunnelData} displayToggleButton={false} />
              <Body />
              <Col sm={12}>
                <Container>
                  <Footer tunnelData={this.props?.tunnelData} />
                </Container>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    )
  }
}

export default FinalPage
